import React from 'react';
import './Utility.css';

import telecomImg from '../images/telecom.png';
import telecomImg2 from '../images/telecom2.png';
import telecomImg3 from '../images/telecom3.png';

const Utility = () => {
  return (
    <div className="utility-container">
      <section className="utility-block">
        <img src={telecomImg} alt="Property Management" className="utility-image" />
        <h1>Property Management Solution</h1>
        <h3>The Problem</h3>
        <p>Absence of a comprehensive digital system that would help keep track of and optimally use a wide variety of assets and their data.</p>
        <h2>Challenge</h2>
        <p>Valuable assets and associated data formed an extremely complex maze as the client’s business grew...</p>
        <h1>Objectives</h1>
        <ul>
          <li>Centralized software for network roll-outs and maintenance.</li>
          <li>Manage assets from acquisition to decommissioning.</li>
          <li>Seamless integration into the existing IT ecosystem.</li>
        </ul>
        <h2>Solution</h2>
        <p>We conducted an in-depth analysis... and deployed the Siterra application...</p>
      </section>

      <section className="utility-block">
        <img src={telecomImg2} alt="OSS/BSS" className="utility-image" />
        <h1>OSS/BSS</h1>
        <h3>Problem</h3>
        <p>Customer wanted to implement a single platform OSS & BSS.</p>
        <h2>Solution</h2>
        <p>OSS & BSS in one platform, Floor plan, rack elevation, Shelf View...</p>
      </section>

      <section className="utility-block">
        <img src={telecomImg3} alt="AssetVaantage" className="utility-image" />
        <h1>AssetVaantage</h1>
        <h2>Project Name</h2>
        <p>Asset Management System.</p>
        <h3>Client</h3>
        <p>A telecom subsidiary of a giant utility company.</p>
        <h1>Our Role</h1>
        <p>Inovaantage was brought in to deploy a strong and reliable asset management service...</p>
      </section>
    </div>
  );
};

export default Utility;
